import { Button, Card, Result } from 'antd';

import React from 'react';

import { Link } from 'react-router-dom';

const Error = () => {
	return (
		<Card>
			<Result
				status="404"
				title="404"
				subTitle="Страница не найдена, уходите"
				extra={
					<Link to="/">
						<Button type="primary">На главную</Button>
					</Link>
				}
			/>
		</Card>
	);
};

export default Error;
